<!-- Pool selection -->
<!-- tw-pt-[5px]
tw-pb-[4px] -->
<div
  [ngClass]="{'tw-hidden': betAmounts?.length === 0}"
  class="
    amount-selection-section
    tw-relative
    tw-w-full
    tw-max-w-[770px]
    tw-overflow-x-auto
    tw-block
    tw-bg-[#C7D8EB]
    tw-rounded-[7px]
    tw-mt-[8px]
    tw-pt-[15px]
    tw-pb-[6px]
    tw-px-[12px]
  "
>
  <div
    class="
      tw-flex
      tw-items-center
      tw-pr-[15px]
      tw-pl-[6px]
    "
  >
    <div
      class="
        current-bets-amount
        tw-leading-[32px]
        tw-flex
        tw-flex-nowrap
        tw-items-start
      "
    >

      @if (betAmounts !== undefined) {
        <div
          class="
            tw-w-auto
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-uppercase
            tw-rounded-[4px]
            tw-relative
            tw-text-center
            tw-mr-[8px]
            tw-pt-[4px]
            tw-pb-[3px]
          "
        >
          <span
            class="
              tw-block
              tw-relative
              tw-w-[48px]
              tw-h-[31px]
              tw-z-1
              tw-text-[#FFFFFF]
              tw-text-[18px]
              tw-cursor-pointer
              tw-bg-[#557DAC]
              tw-rounded-[4px]
            "
          >
            <div
              class="
                dollar-icon
                tw-bg-[#FCFCFC]
                tw-rounded-[15px]
                tw-text-[#557DAC]
              "
            >
              $
            </div>
          </span>
          <!-- <img
            class="
              tw-absolute
              tw-z-0
              tw-top-[0px]
              tw-right-[0px]
              tw-bottom-[0px]
              tw-left-[0px]
            "
            src="/assets/images/wager/bet_amount_active_icon.svg"
            alt="bet amount active icon"
          >
          <img
            class="
              tw-relative
              tw-z-1
              tw-w-[22px]
              tw-mx-auto
              tw-mt-[6px]
            "
            src="/assets/images/wager/bet_dollar_icon_light.png"
            alt="bet dollar light icon"
          > -->
        </div>

        <div
          [class.active]="selectedAmount === amount"
          (click)="chooseAmount(amount, i)"
          *ngFor="let amount of betAmounts; let i = index"
          [attr.data-amount]="amount"
          class="
            bet-amount-chip
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-uppercase
            tw-cursor-pointer
            tw-select-none
            tw-rounded-[4px]
            tw-relative
            tw-text-center
            tw-mr-[8px]
            tw-mb-[2px]
            tw-pt-[4px]
            tw-pb-[3px]
          "
        >

          @if (!((amount < minBet) || (amount > maxBet))) {
            <!-- <img
              [id]="'id-' + i"
              class="
                default
                tw-absolute
                tw-z-0
                tw-top-[0px]
                tw-right-[0px]
                tw-bottom-[0px]
                tw-left-[0px]
              "
              src="/assets/images/wager/bet_amount_icon.svg"
              alt="bet amount icon"
            >
            <img
              [id]="'id-' + i"
              class="
                active
                tw-hidden
                tw-absolute
                tw-z-0
                tw-top-[0px]
                tw-right-[0px]
                tw-bottom-[0px]
                tw-left-[0px]
              "
              src="/assets/images/wager/bet_amount_active_icon.svg"
              alt="bet amount active icon"
            > -->
            <span
              [ngClass]="{'tw-w-[58px]': amount === 1000}"
              class="
                tw-block
                tw-w-[48px]
                tw-h-[31px]
                tw-relative
                tw-z-1
                tw-text-[#FFFFFF]
                tw-text-[18px]
                tw-cursor-pointer
                tw-bg-[#2D5B8B]
                tw-rounded-[4px]
                tw-px-[7px]
              "
            >
              {{ amount }}
            </span>
          }

        </div>

        <div
          [class.active]="otherAmount > 0"
          id="others"
          (click)="inputAmount()"
          class="
            bet-amount-chip
            tw-w-auto
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-cursor-pointer
            tw-select-none
            tw-rounded-[4px]
            tw-relative
            tw-text-center
            tw-pt-[4px]
            tw-pb-[3px]
          "
        >
          <!-- <img
            id="other-default"
            [class.tw-hidden]="otherAmount < 1"
            class="
              tw-absolute
              tw-z-0
              tw-top-[0px]
              tw-right-[0px]
              tw-bottom-[0px]
              tw-left-[0px]
            "
            src="/assets/images/wager/bet_amount_icon.svg"
            alt="bet amount icon"
          >
          <img
            id="other-active"
            [class.tw-hidden]="otherAmount > 0"
            class="
              tw-absolute
              tw-z-0
              tw-top-[0px]
              tw-right-[0px]
              tw-bottom-[0px]
              tw-left-[0px]
            "
            src="/assets/images/wager/bet_amount_active_icon.svg"
            alt="bet amount active icon"
          > -->
          <span
            class="
              tw-block
              tw-h-[31px]
              tw-relative
              tw-z-1
              tw-text-[#FFFFFF]
              tw-text-[18px]
              tw-cursor-pointer
              tw-bg-[#2D5B8B]
              tw-rounded-[4px]
              tw-px-[7px]
            "
          >
            {{ otherAmount || ('generic.other' | translate: 'Other') | numberWithCommas }}
            <!-- {{ otherAmount ? (otherAmount | number: '1.0-0') : 'Other' }} -->
          </span>
        </div>
      }

    </div>
  </div>
</div>
